module.exports = __webpack_public_path__ + "img/no.41e05b2b.svg";